import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { ConfirmationDialogComponent } from 'src/app/ChildControls/confirmation-dialog/confirmation-dialog.component';
import { Component_RoleMasterEnum, UserRoleservice } from 'src/app/Services/common.service';
import { configuration } from 'src/environments/environment';
import { CCDAService } from '../ccda.service';
import { DataExportRecursiveComponent } from './data-export-recursive/data-export-recursive.component';

@Component({
  selector: 'app-patient-clinical-data-export',
  templateUrl: './patient-clinical-data-export.component.html',
  styleUrls: ['./patient-clinical-data-export.component.css']
})
export class PatientClinicalDataExportComponent implements OnInit {
  PatientClinicalDataExportList: any = [];
  UserPermissions: string = '';
  @ViewChild('template', { static: false }) templateRef: TemplateRef<any>;
  constructor(private _ccdaService: CCDAService,
    private _userRoleservice: UserRoleservice,
    private _toastrService: ToastrService,
    public dialog: MatDialog,
    private spinner: NgxSpinnerService) {


  }

  ngOnInit() {
    this.fnGetData();
    this.UserPermissions = this._userRoleservice.getPermissionsByComponentId(Component_RoleMasterEnum.ClinicalDataExport);
  }
  fnGetData() {
    this.spinner.show();
    this._ccdaService.GetClinicalDataExport("0").subscribe(result => {
      this.PatientClinicalDataExportList = result;
      this.spinner.hide();
    })
  }
  openGenarateCCDA(FilePath) {
    //const url = configuration.clinicTokenUrl + '/Downloads/' + FilePath;//  window.URL.createObjectURL(blob);
    const url = configuration.ClinicalDataExport_DownloadURL + '/Downloads/' + FilePath;//  window.URL.createObjectURL(blob);
    window.open(url);
  }
  fnDelete(id) {
    const dialogRef2 = this.dialog.open(ConfirmationDialogComponent, {
      width: '300px',
      height: '150px',
      data: { headerText: 'Do you want to delete this record?' }
    });
    dialogRef2.afterClosed().subscribe(dialogResult => {
      if (dialogResult == true) {
        this._ccdaService.DeleteClinicalDataExport(id).subscribe((result: string) => {
          if (result.indexOf('success') > -1) {
            this.PatientClinicalDataExportList = this.PatientClinicalDataExportList.filter(i => i.ID != id);
            this._toastrService.success("Successfully Deleted");
          }
          else {
            this._toastrService.error(result);
          }
        });
      }

    })

  }
  openModal(details) {
    this.dialog.open(DataExportRecursiveComponent, {
      data: { details }
    });
  }
}
